import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import styled from './styled';
import { Mixpanel } from 'helpers/Mixpanel';

class StatusCell extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};

    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentDidUpdate(prevProps) {

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  trackAndShowInviteModal(user) {
    const { handleShowSMSInviteModal } = this.props;
    Mixpanel.track('Clicked invite on UM row', { 'user_id': user.id });
    handleShowSMSInviteModal(user);
  }

  render() {
    const { user, handleShowSMSInviteModal } = this.props;

    const active1 = (<FormattedMessage
      id="StatusCell.active1"
      defaultMessage="Active"
    />);

    const pending = (<FormattedMessage
      id="StatusCell.pending"
      defaultMessage="Pending"
    />);

    const terminated = (<FormattedMessage id="StatusCell.terminated" defaultMessage="Terminated" />);
    const unregistered = (<FormattedMessage id="StatusCell.unregistered" defaultMessage="Unregistered" />);
    const inviteText = (<FormattedMessage id="StatusCell.invite" defaultMessage="Invite" />);

    if (user && user.status === 'active') {
      return (
        <styled.StatusActive>
          <styled.ActiveSpan />
          <styled.ActiveText>{active1}</styled.ActiveText>
        </styled.StatusActive>
      );
    } else if (user && user.status === 'pending') {
      return (
        <styled.StatusPending>
          <styled.PendingSpan />
          <styled.PendingText>{pending}</styled.PendingText>
        </styled.StatusPending>
      );
    } else if ((user && user.status === 'removed') || (user && user.status === 'rejected') || (user && user.status === 'withdrawn')) {
      return (
        <styled.StatusFailed>
          <styled.FailedSpan />
          <styled.FailedText>{terminated}</styled.FailedText>
        </styled.StatusFailed>
      );
    } else if ((user && user.status === 'unregistered')) {
      return (
        <styled.UnregisteredWrap>
          <styled.StatusPending>
            <styled.PendingSpan />
            <styled.PendingText>{unregistered}</styled.PendingText>
          </styled.StatusPending>
          {handleShowSMSInviteModal && true && <styled.inviteLink onClick={() => { this.trackAndShowInviteModal(user); }}>{inviteText} </styled.inviteLink>}
        </styled.UnregisteredWrap>
      );
    } else {
      return null;
    }
  }
}


export default injectIntl(StatusCell);